import { logEvent } from "@shared/analytics/analytics";
import { DeleteConfirmationDialog } from "@shared/components/deleteComformationModal";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { toast } from "@shared/ui/use-toast";
import { Edit, Plus, Trash2 } from "lucide-react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDeleteAsset } from "../../hooks";

export const AssetQuickActionsSidebar: React.FC<{ data: any }> = ({ data }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  // Delete confirmation dialog state
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [assetToDelete, setAssetToDelete] = useState<any>(null);

  const handleDeleteClick = () => {
    setAssetToDelete(data);
    setShowDeleteDialog(true);
  };
  const { mutate: deleteAssetMutation, isPending: isDeletingAsset } =
    useDeleteAsset();
  const handleConfirmDelete = () => {
    if (assetToDelete) {
      logEvent("Asset Delete Confirmed", {
        facilityId: assetToDelete.id,
      });
      deleteAssetMutation(
        { assetId: assetToDelete.id },
        {
          onSuccess: () => {
            toast({
              title: "Success",
              description: `"${assetToDelete.assetName}" has been deleted successfully.`,
            });
            setShowDeleteDialog(false);
            setAssetToDelete(null);
            navigate("/ax/asset-registry/assets");
          },
          onError: (error) => {
            toast({
              title: "Delete Failed",
              description: error.message,
              variant: "destructive",
            });
          },
        }
      );
    }
  };

  const handleDeleteDialogClose = () => {
    setShowDeleteDialog(false);
    setAssetToDelete(null);
  };
  return (
    <div>
      <Card className="h-fit p4">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Quick Actions</CardTitle>
          <p className="text-sm text-gray-600">Common asset management tasks</p>
        </CardHeader>
        <CardContent className="space-y-3 flex flex-col">
          <Button
            variant="outline"
            className="w-full justify-start p-2"
            size="sm"
            onClick={() => {
              navigate(`/ax/asset-registry/assets/create/edit/${id}`);
            }}
          >
            <Edit className="h-4 w-4 mr-2" />
            <p>Edit Asset</p>
          </Button>

          <Button
            variant="outline"
            className="w-full justify-start p-2"
            onClick={() => navigate("/ax/service-order/landing/create")}
          >
            <Plus className="h-4 w-4 mr-2" />
            Create Service Order
          </Button>
          <Button
            variant="outline"
            className="w-full justify-start p-2"
            onClick={handleDeleteClick}
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </Button>
        </CardContent>
      </Card>
      <DeleteConfirmationDialog
        isOpen={showDeleteDialog}
        onClose={handleDeleteDialogClose}
        onConfirm={handleConfirmDelete}
        title="Delete Assets"
        itemName={data?.assetName}
        description={`Are you sure you want to delete the asset "${data?.assetName}" (ID: ${data?.assetNo})? This will permanently remove the asset and all its associated data. This action cannot be undone.`}
        isLoading={isDeletingAsset}
      />
    </div>
  );
};
